import { render } from "./Searchbox.vue?vue&type=template&id=353706fb&scoped=true&ts=true"
import script from "./Searchbox.vue?vue&type=script&lang=ts"
export * from "./Searchbox.vue?vue&type=script&lang=ts"

import "./Searchbox.vue?vue&type=style&index=0&id=353706fb&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353706fb"]])

export default __exports__